import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, throwError } from 'rxjs';
import {
  FormData,
  FormDataItem,
  FormElementItem,
} from 'src/app/interfaces/form-data';
import { RequestsService } from 'src/app/services/requests.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-action-detailed-info',
  templateUrl: './action-detailed-info.component.html',
  styleUrls: [],
})
export class ActionDetailedInfoComponent implements OnInit {
  @Input() selection: any;
  @Input() info: any;
  request: any;

  formData: FormData | undefined;

  customFunctions = {
    refresh: (field: FormDataItem, formData: FormData) => {
      console.log('$refresh()', field, formData);
    },
    action: (element: FormElementItem, formData: FormData) => {
      console.log('$action()', element, formData);
    },
  };

  constructor(
    private readonly modalService: NgbModal,
    private readonly requestService: RequestsService,
    private readonly activeModal: NgbActiveModal,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.spinnerService.open();
    console.log('selection: ', this.selection);
    this.requestService
      .getRequest(this.info.requestId)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.close();
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe((data: any) => {
        this.request = data;
        this.formData = data.form;
        this.spinnerService.close();
      });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  confirmRejection() {
    this.activeModal.close(this.selection);
  }
  confirmApproval() {
    this.activeModal.close(this.selection);
  }
}
